import { inject, Injectable } from '@angular/core';
import { EventCategory, EventDescription, EventName } from '../interfaces';
import { ENV, IEnv } from '@pf/shared/config';

// Needed to reach the global gtag function
declare let gtag: (...args: unknown[]) => void;

@Injectable({ providedIn: 'root' })
export class Analytics {
  readonly env: IEnv = inject(ENV);
  trackEventByName(eventName: string) {
    const eventNameKey = Object.keys(EventName).find(k => EventName[k as keyof typeof EventName] === eventName);
    if (this.env.production) {
      this.trackEvent(
        EventName[eventNameKey as keyof typeof EventName],
        EventDescription[eventNameKey as keyof typeof EventDescription],
        EventCategory[eventNameKey as keyof typeof EventCategory],
      );
    } else {
      // Log event for testing purposes, only on test/local environment
      console.log('Tracking event: ', eventName);
      console.log({
        EventName: EventName[eventNameKey as keyof typeof EventName],
        EventDescription: EventDescription[eventNameKey as keyof typeof EventDescription],
        EventCategory: EventCategory[eventNameKey as keyof typeof EventCategory],
      });
    }
  }

  trackEvent(eventName: EventName, eventDetails: EventDescription, eventCategory: EventCategory) {
    gtag('event', eventName, {
      // Event Category - example: 'Aanvragen: Workflow States'
      event_category: eventCategory,
      // The label that will show up in the dashboard as the events name - example: 'State_PakOp'
      event_label: eventName,
      // A short description of the event - plain text
      value: eventDetails,
    });
  }
}
